import React from 'react'
import { connect } from 'react-redux'

function NotFound(props) {

    return (
        <React.Fragment>
            <h1>404</h1>
        </React.Fragment >
    )
}

export default connect()(NotFound)
